(function(){
'use strict';

function money(cents){
  try{return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format((Number(cents)||0)/100)}
  catch(e){return '£'+((Number(cents)||0)/100).toFixed(2)}
}
function route(path){
  var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  return base+String(path||'').replace(/^\//,'');
}
function parse(root,selector,fallback){
  try{return JSON.parse((root.querySelector(selector)||{}).textContent||'')||fallback}catch(e){return fallback}
}
function boot(root){
  if(!root||root.dataset.fl4Ready==='1')return;
  root.dataset.fl4Ready='1';

  var variants=parse(root,'[data-fl4-variants]',[]);
  var form=root.querySelector('[data-fl3-product-form]');
  var variantInput=root.querySelector('[data-fl3-variant-id]');
  var qtyInput=root.querySelector('[data-fl3-qty]');
  var hiddenQty=root.querySelector('[data-fl3-hidden-qty]');
  var status=root.querySelector('[data-fl4-status]');
  var atc=root.querySelector('[data-fl3-atc]');
  var deliveryWrap=root.querySelector('[data-fl5-delivery]');
  var deliveryInput=root.querySelector('[data-fl5-delivery-date]');
  var deliveryMessage=root.querySelector('[data-fl5-delivery-message]');
  var DELIVERY_KEY='flayvr_delivery_date_v1';

  function say(text,state){
    if(!status)return;
    status.textContent=text||'';
    status.dataset.state=state||'';
  }
  function selectedOptions(){
    return Array.prototype.map.call(root.querySelectorAll('[data-fl3-option-group]'),function(group){
      var b=group.querySelector('[data-fl3-option].is-active');
      return b?String(b.dataset.value||''):'';
    });
  }
  function variantFor(options){
    if(!options.length){
      var id=Number(variantInput&&variantInput.value);
      return variants.find(function(v){return Number(v.id)===id})||variants[0]||null;
    }
    return variants.find(function(v){
      var vo=v.options||[];
      return vo.length===options.length&&vo.every(function(x,i){return String(x)===String(options[i])});
    })||null;
  }
  function currentVariant(){return variantFor(selectedOptions())}

  function updateOptionAvailability(){
    var groups=Array.prototype.slice.call(root.querySelectorAll('[data-fl3-option-group]'));
    groups.forEach(function(group,index){
      group.querySelectorAll('[data-fl3-option]').forEach(function(btn){
        var test=selectedOptions();
        test[index]=String(btn.dataset.value||'');
        var possible=variants.some(function(v){
          if(!v.available)return false;
          return (v.options||[]).every(function(opt,i){
            return i===index?String(opt)===test[i]:(!test[i]||String(opt)===test[i]);
          });
        });
        btn.disabled=!possible;
      });
    });
  }

  function sync(v,pushUrl){
    if(!v){
      if(atc)atc.disabled=true;
      var label=root.querySelector('[data-fl3-atc-label]');
      if(label)label.textContent='Unavailable combination';
      say('That combination is not available.','error');
      return;
    }
    say('');
    if(variantInput)variantInput.value=v.id;

    var price=root.querySelector('[data-fl3-price]');
    var mobile=root.querySelector('[data-fl3-mobile-price]');
    if(price)price.textContent=money(v.price);
    if(mobile)mobile.textContent=money(v.price);

    var compare=root.querySelector('[data-fl3-compare]');
    if(compare){
      if(Number(v.compare_at_price)>Number(v.price)){
        compare.hidden=false;compare.textContent=money(v.compare_at_price);
      }else{compare.hidden=true;compare.textContent=''}
    }

    var per=root.querySelector('[data-fl3-per-person]');
    var servesText=(per&&per.textContent.match(/·\s*(.*)$/)||[])[1]||'';
    var servesNum=Number(root.dataset.servesNumber||0);
    if(per&&servesNum>0)per.textContent=money(Math.round(Number(v.price)/servesNum))+' each'+(servesText?' · '+servesText:'');

    if(atc){
      atc.disabled=!v.available;
      var l=root.querySelector('[data-fl3-atc-label]');
      if(l)l.textContent=v.available?'Add to basket · '+money(v.price):'Sold out';
    }

    var image=root.querySelector('[data-fl3-hero]');
    if(image&&v.featured_image){
      var next=(typeof v.featured_image==='string')?v.featured_image:(v.featured_image.src||'');
      if(next){image.src=next;image.removeAttribute('srcset')}
    }

    if(pushUrl!==false&&window.history&&window.history.replaceState){
      try{
        var u=new URL(window.location.href);
        u.searchParams.set('variant',v.id);
        window.history.replaceState({variant:v.id},'',u.toString());
      }catch(e){}
    }
    root.dispatchEvent(new CustomEvent('flayvr:pdp:variant',{detail:{
      variantId:Number(v.id),price:Number(v.price),priceFormatted:money(v.price),available:Boolean(v.available)
    }}));
    updateOptionAvailability();
  }

  root.querySelectorAll('[data-fl3-option]').forEach(function(btn){
    btn.addEventListener('click',function(){
      if(btn.disabled)return;
      var group=btn.closest('[data-fl3-option-group]');
      group.querySelectorAll('[data-fl3-option]').forEach(function(x){x.classList.remove('is-active');x.setAttribute('aria-pressed','false')});
      btn.classList.add('is-active');btn.setAttribute('aria-pressed','true');
      var label=group.querySelector('[data-fl3-option-label]');
      if(label)label.textContent=btn.dataset.value||btn.textContent;
      sync(currentVariant(),true);
    });
  });

  root.querySelectorAll('[data-fl4-preference-choice]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var group=btn.closest('[data-fl4-preference]');
      group.classList.remove('is-error');
      group.querySelectorAll('[data-fl4-preference-choice]').forEach(function(x){x.classList.remove('is-active');x.setAttribute('aria-pressed','false')});
      btn.classList.add('is-active');btn.setAttribute('aria-pressed','true');
      var value=String(btn.dataset.value||btn.textContent||'').trim();
      var input=group.querySelector('[data-fl4-property]');
      var label=group.querySelector('[data-fl4-preference-label]');
      if(input)input.value=value;
      if(label)label.textContent=value;
      say('');
    });
  });


  function isoDate(d){
    return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
  }
  function parseDateOnly(value){
    var parts=String(value||'').split('-').map(Number);
    if(parts.length!==3||parts.some(function(n){return !Number.isFinite(n)}))return null;
    return new Date(parts[0],parts[1]-1,parts[2],12,0,0,0);
  }
  function earliestDeliveryDate(){
    var d=new Date();d.setHours(12,0,0,0);d.setDate(d.getDate()+2);
    while(d.getDay()===0)d.setDate(d.getDate()+1);
    return d;
  }
  function deliverySay(text,state){
    if(deliveryMessage){deliveryMessage.textContent=text||'';deliveryMessage.dataset.state=state||''}
    if(deliveryWrap)deliveryWrap.classList.toggle('is-error',state==='error');
  }
  function getDeliveryDate(){return deliveryInput?String(deliveryInput.value||'').trim():''}
  function persistDeliveryDate(value){
    try{if(value)window.sessionStorage.setItem(DELIVERY_KEY,value);else window.sessionStorage.removeItem(DELIVERY_KEY)}catch(e){}
  }
  function validateDeliveryDate(focus){
    if(!deliveryInput)return true;
    var value=getDeliveryDate(), selected=parseDateOnly(value), earliest=earliestDeliveryDate();
    if(!selected){deliverySay('Choose a delivery date before adding to basket.','error');if(focus)deliveryInput.focus();return false}
    if(selected<earliest){deliverySay('We need at least 2 days’ notice for delivery.','error');if(focus)deliveryInput.focus();return false}
    if(selected.getDay()===0){deliverySay('We don’t deliver on Sundays. Please choose another day.','error');if(focus)deliveryInput.focus();return false}
    persistDeliveryDate(value);
    if(selected.getDay()===6)deliverySay('Saturday delivery is limited. Monday–Friday is recommended where possible.','');
    else deliverySay('Delivery date selected.','');
    return true;
  }
  function initDeliveryDate(){
    if(!deliveryInput)return;
    var earliest=earliestDeliveryDate();deliveryInput.min=isoDate(earliest);
    var saved='';try{saved=window.sessionStorage.getItem(DELIVERY_KEY)||''}catch(e){}
    if(saved){var parsed=parseDateOnly(saved);if(parsed&&parsed>=earliest&&parsed.getDay()!==0)deliveryInput.value=saved;else persistDeliveryDate('')}
    if(deliveryInput.value)validateDeliveryDate(false);
    deliveryInput.addEventListener('change',function(){validateDeliveryDate(false)});
  }
  initDeliveryDate();

  function properties(){
    var out={};
    root.querySelectorAll('[data-fl4-property]').forEach(function(input){
      var name=String(input.dataset.propertyName||'').trim();
      var value=String(input.value||'').trim();
      if(name&&value)out[name]=value;
    });
    return out;
  }
  function validatePreferences(){
    var ok=true;
    root.querySelectorAll('[data-fl4-preference][data-required="true"]').forEach(function(group){
      var input=group.querySelector('[data-fl4-property]');
      var valid=Boolean(input&&String(input.value||'').trim());
      group.classList.toggle('is-error',!valid);
      if(!valid)ok=false;
    });
    if(!ok)say('Choose the required option before adding this kit.','error');
    return ok;
  }
  function setQty(value){
    var n=Math.max(1,parseInt(value,10)||1);
    if(qtyInput)qtyInput.value=n;
    if(hiddenQty)hiddenQty.value=n;
    return n;
  }
  root.querySelector('[data-fl3-minus]') && root.querySelector('[data-fl3-minus]').addEventListener('click',function(){setQty(Number(qtyInput.value)-1)});
  root.querySelector('[data-fl3-plus]') && root.querySelector('[data-fl3-plus]').addEventListener('click',function(){setQty(Number(qtyInput.value)+1)});
  qtyInput && qtyInput.addEventListener('change',function(){setQty(qtyInput.value)});

  async function addCurrent(button){
    var v=currentVariant();
    if(!v||!v.available){say('This option is currently unavailable.','error');return false}
    if(!validatePreferences())return false;
    if(!validateDeliveryDate(true))return false;
    var old=button&&button.textContent;
    if(button)button.disabled=true;
    say('Adding…');
    try{
      var response=await fetch(route('cart/add.js'),{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{
          id:Number(v.id),
          quantity:setQty(qtyInput?qtyInput.value:1),
          properties:properties()
        }]})
      });
      if(!response.ok)throw new Error('cart add failed');
      if(button)button.textContent='Added ✓';
      say('Added to basket.');
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      setTimeout(function(){if(button&&old)button.textContent=old;say('')},1600);
      return true;
    }catch(e){
      say('Could not add automatically. Opening the normal product form.','error');
      try{
        if(form){form.removeEventListener('submit',onSubmit);form.submit()}
      }catch(err){}
      return false;
    }finally{
      if(button)button.disabled=false;
    }
  }
  function onSubmit(e){e.preventDefault();addCurrent(atc)}
  form && form.addEventListener('submit',onSubmit);
  root.querySelector('[data-fl3-mobile-atc]') && root.querySelector('[data-fl3-mobile-atc]').addEventListener('click',function(e){addCurrent(e.currentTarget)});
  root.querySelector('[data-fl3-closer-atc]') && root.querySelector('[data-fl3-closer-atc]').addEventListener('click',function(e){addCurrent(e.currentTarget)});

  root.__flayvrPdp={
    getVariant:function(){return currentVariant()},
    getProperties:properties,
    validatePreferences:validatePreferences,
    validateDeliveryDate:validateDeliveryDate,
    getDeliveryDate:getDeliveryDate,
    persistDeliveryDate:persistDeliveryDate,
    addCurrent:addCurrent
  };

  root.querySelectorAll('[data-fl3-faq]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var row=btn.closest('.fl3-faq');
      var open=!row.classList.contains('is-open');
      row.classList.toggle('is-open',open);
      btn.setAttribute('aria-expanded',String(open));
    });
  });

  root.querySelector('[data-fl3-share]') && root.querySelector('[data-fl3-share]').addEventListener('click',async function(){
    if(navigator.share){try{await navigator.share({title:document.title,url:location.href})}catch(e){}}
    else if(navigator.clipboard){try{await navigator.clipboard.writeText(location.href);say('Link copied.')}catch(e){}}
  });

  updateOptionAvailability();
  sync(currentVariant(),false);
}
function bootAll(scope){
  (scope||document).querySelectorAll('[data-flayvr-master-pdp]').forEach(boot);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){bootAll(document)},{once:true});
else bootAll(document);
document.addEventListener('shopify:section:load',function(e){bootAll(e.target||document)});
})();